

export interface SorterDefinition {
    name: string;
    code: string;
}